module.exports = __webpack_public_path__ + "static/media/d.c11a8d15.png";